import React, { Fragment, Component } from 'react';

import { Link } from 'react-router-dom';

import piramisLogo from '../../../assets/logo-piramis.png';

class SidebarHeader extends Component {
  render() {
    return (
      <Fragment>
        <div className="app-sidebar--header bg-neutral-primary">
          <div className="nav-logo">
            <Link
              to="/"
              title="Piramis Locator CRM"
            >
              <i>
                {<img style={{ animation: "none" }}
                  alt="Piramis Locator logo"
                  src={piramisLogo}
                />}
              </i>
              <span>Piramis Locator CRM</span>
            </Link>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default SidebarHeader;
